import type { ReactElement } from 'react'
import BlockedPage from 'pages/errors/blocked-page'
import LoadingProgress from 'components/common/loader/loading-progress'
import { useApiGetStores } from '../api/store/useApiGetStores'
import { useApiGetTemplates } from '../api/template/useApiGetTemplates'
import { useApiGetAccounts } from '../api/account/useApiGetAccounts'
import { useApiMenuGetUserPreferences } from '../api/menu/useApiMenuGetUserPreferences'
import { useCountries } from '../api/country/useCountries'
import { useApiGetApiDailyTemplates } from '../api/template/useApiGetDailyTemplates'
import { useApiGetAnnouncement } from '../api/announcement/useApiGetAnnouncement'
import { useApiGetSportsGroup } from '../api/sports-group/useApiGetSportsGroup'
import { useApiGetAggregates } from '../api/aggregate/useApiGetCalenderAggregate'
import { useTranslation } from 'react-i18next'

interface IAppInitializeProps {
  children: ReactElement
}

const RessourcesProvider = ({ children }: IAppInitializeProps) => {
  const { t } = useTranslation()
  // API Call : No PUT endpoint. The data will always stay fresh.
  // Have the option: staleTime: Infinity
  useCountries()
  useApiGetSportsGroup()
  const { error: storesError, isLoading: storesLoading } = useApiGetStores()
  const { error: accountsError, isLoading: accountsLoading } = useApiGetAccounts()
  useApiGetAggregates({ gcTime: Infinity })

  // API Call: Have PUT endpoint but very few used.
  // Have the option : staleTime: Infinity
  // After a PUT, the GET query cache is invalidate that trigger a new fetch.
  const { error: userError, isLoading: userLoading } = useApiMenuGetUserPreferences()
  const { error: templateError, isLoading: templatesLoading } = useApiGetTemplates()
  useApiGetApiDailyTemplates()
  useApiGetAnnouncement()

  const ressourcesHaveError = userError || accountsError || templateError || storesError
  const areRessourcesPending = userLoading || storesLoading || templatesLoading || accountsLoading

  const renderChildren = () => {
    if (ressourcesHaveError) {
      return <BlockedPage title={t('unavailable.title')} content={t('unavailable.content')} />
    }
    if (areRessourcesPending) {
      return <LoadingProgress />
    }
    return children
  }

  return renderChildren()
}

export default RessourcesProvider
